import EmailActivityHeader from './EmailActivityHeader';

export default EmailActivityHeader;
